/**
 * Builds out a page title in the format "<subtitle> - Inside Rx."
 *
 * @param {string} globalTitle - The global social title.
 * @param {string} [subtitle] - Optional subtitle for the page.
 * @returns {string}
 */
export const buildTitle = (globalTitle: string, subtitle?: string): string => {
  if (!subtitle) return globalTitle;

  // we don't want to return "Inside Rx - Inside Rx"
  if (subtitle === globalTitle) return globalTitle;

  const title = globalTitle && !subtitle.includes('Inside Rx') ? `${subtitle} - ${globalTitle}` : subtitle;

  return title;
};
